import { useCallback, useEffect, useRef, useState, useTransition } from 'react';

import { fetchListRoles } from '~modules/role/api';
import { RoleDto } from '~modules/role/dto';

export function useRoles(sectionId: number | null) {
	const [list, setList] = useState<RoleDto[]>([]);
	const [pending, startLoading] = useTransition();
	const isFirstRender = useRef(true);

	const refresh = useCallback(() => {
		if (!sectionId) setList([]);
		else {
			startLoading(async () => {
				const data = await fetchListRoles(sectionId);
				setList(data);
			});
		}
	}, [sectionId]);

	useEffect(() => {
		isFirstRender.current = false;
		refresh();
	}, [refresh]);

	return { pending, list };
}
